<div class="container-fluid   ">


    <div class="row pt-5 pb-3">
        <div class="col-6 col-md-8">
            <!-- zone Scores -->

            <div class="row">
                <div class="col-4 col-md-4">
                    <div class="p-3 mb-2 d-flex"
                        style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                        <img src="../../../../assets/core-img/safety_score.png" alt="">
                        <p class=" px-3 mt-2 scoreFontFamily">50 % </p>
                        <div class="vr"></div>
                        <mat-icon class="mt-2" style="color: #4ca846b5;"> arrow_upward </mat-icon>
                        <div class="vr"></div>
                        <p class=" px-3 mt-2 scoreFontFamily">130.02 Km </p>
                        <p class="scoreFontFamilyCommentaire">entre les risques</p>
                    </div>
                    <div class="p-3 mb-2 d-flex"
                        style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                        <img src="../../../../assets/core-img/eco_score.png" alt="">
                        <p class=" px-3 mt-2 scoreFontFamily">50 % </p>
                        <div class="vr"></div>
                        <mat-icon class="mt-2" style="color: #4ca846b5;"> arrow_upward </mat-icon>
                        <div class="vr"></div>
                        <p class=" px-3 mt-2 scoreFontFamily">25 % </p>
                        <p class="scoreFontFamilyCommentaire">inactivité moyenne</p>
                    </div>

                    <div class="p-3 mb-2 mt-2"
                        style="background: #323d415c; border-radius: 6px;    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                        <div class="col-3 col-md-12 w-100">
                            <div class="row">
                                <div class="col-6 col-md-2 w-100">
                                    <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                        <img (click)="exportExcel(exportDirective, 'xlsx')"
                                            src="https://img.icons8.com/color/48/000000/export-excel.png" />


                                    </div>
                                </div>
                                <div class="col-6 col-md-3 w-100">
                                    <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                        <img (click)="exportExcel(exportDirective, 'csv')"
                                            src="https://img.icons8.com/color/48/000000/export-csv.png" />

                                    </div>
                                </div>
                                <div class="col-6 col-md-2 w-100">
                                    <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                        <!-- <img (click)="triggerFalseClick()"  src="https://img.icons8.com/color/50/000000/json-download.png"/>-->
                                        <img (click)="exportExcel(exportDirective, 'json')"
                                            src="https://img.icons8.com/color/50/000000/json-download.png" />

                                    </div>
                                </div>
                                <div class="col-6 col-md-3 w-100">
                                    <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                        <!--      <img (click)="exportDirective.exportTable('txt',{
                          fileName: 'IncomingMessageReport.txt',
                          sheet: 'list',
                          Props: { Author: 'STG' ,Title: 'STG',Subject: 'lhkjhkhug' }
                        })" src="https://img.icons8.com/color/50/000000/rich-text-converter.png"/>-->
                                        <img (click)="exportExcel(exportDirective, 'txt')"
                                            src="https://img.icons8.com/color/50/000000/rich-text-converter.png" />
                                    </div>
                                </div>
                                <div class="col-6 col-md-2 w-100">
                                    <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                        <img src="https://img.icons8.com/color/48/000000/export-pdf.png" />

                                    </div>
                                </div>
                            </div>





                        </div>
















                    </div>



                </div>
                <div class="col-8 col-md-8">

                    <div
                        style="background: white; border-radius: 6px ;    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                        <ul class="list-group">
                            <li class="list-group-item active" style="color: #ffffff">
                                <i class="fa fa-tablet"></i>
                                Détails de trajet
                            </li>
                        </ul>
                        <div class="row">


                            <div class="col-6 col-md-6">

                                <div class="col-12 col-md-3 w-100 my-3  p-2 "
                                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                                    <div class="row px-2 ">
                                        <table class="table table-hover w-100" style="border-style: hidden;">
                                            <thead class="d-none">
                                                <tr class="d-none">
                                                    <th scope="col">Last</th>
                                                    <th scope="col">Handle</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><b>Véhicule</b> </td>
                                                    <td style="max-width:20px; word-wrap:break-word;">@twitter</td>
                                                </tr>

                                                <tr>
                                                    <td><b>Début</b></td>
                                                    <td style="max-width:40px; word-wrap:break-word;">khfksd</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Fin</b></td>
                                                    <td style=" word-wrap:break-word;">@fat</td>
                                                </tr>
                                                <tr>
                                                    <td> <b>Durée</b></td>
                                                    <td style="max-width:40px; word-wrap:break-word;">@twitter</td>
                                                </tr>



                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-6">

                                <div class="col-12 col-md-3 w-100 my-3  p-2 "
                                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                                    <div class="row px-2 ">
                                        <table class="table table-hover w-100" style="border-style: hidden;">
                                            <thead class="d-none">
                                                <tr class="d-none">
                                                    <th scope="col">Last</th>
                                                    <th scope="col">Handle</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><b>Conducteur</b> </td>
                                                    <td style="max-width:20px; word-wrap:break-word;">@twitter</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Temps d'inactivité</b> </td>
                                                    <td style="max-width:20px; word-wrap:break-word;">@twitter</td>
                                                </tr>

                                                <tr>
                                                    <td><b>Vitesse moyenne</b></td>
                                                    <td style="max-width:40px; word-wrap:break-word;">khfksd</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Vitesse maximum</b></td>
                                                    <td style=" word-wrap:break-word;">@fat</td>
                                                </tr>
                                                <tr>


                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>


                        </div>




                    </div>
                </div>
            </div>




            <hr>
            <!-- zone tableau -->

            <div class="row">


                <div class="col-3 col-md-2 w-100">
                    <mat-form-field appearance="fill">
                        <mat-label>Page</mat-label>
                        <mat-select>
                            <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)"
                                [value]="item">
                                {{ item }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-3 col-md-2 w-100">
                    <mat-form-field appearance="fill">
                        <mat-label>Eléments</mat-label>

                        <mat-select [(ngModel)]="pageSize">
                            <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"
                                [value]="pageSize">
                                {{ pageSize }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-1 col-md-1 w-100 ">

                </div>
                <div class="col-5 col-md-5  mb-3 w-100">
                    <mat-form-field appearance="fill">
                        <mat-label>Rechercher</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>

                </div>
                <div class="col-2 col-md-2 w-100 ">
                    <button class="w-100" (click)="desactiveSimulation()" *ngIf="simulation" mat-raised-button
                        color="primary">Désactiver Simulation</button>
                    <button class="w-100" (click)="mockDirections()" *ngIf="!simulation" mat-raised-button
                        color="accent">Activer Simulation</button>
                </div>
            </div>






            <div class="row" style="    padding-left: 15px !important;
padding-right: 15px !important;">
                <div class="example-container  mat-elevation-z8">

                    <mat-table #table #exportDirective="matTableExporter" matTableExporter [dataSource]="dataSource"
                        matSort>




                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex  }" mat-cell
                                *matCellDef="let element"> {{element.ID}} </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element" [style.color]="element.typeExport"> {{element.date}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="information">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Information </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element"> {{element.statut}} </td>
                        </ng-container>

                        <ng-container matColumnDef="lieu">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lieu </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element"> {{element.SubValue}} </td>
                        </ng-container>

                        <ng-container matColumnDef="vitesse_min">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vitesse min </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element">
                                {{element.ID}}km/h
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="vitesse_moy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Vitesse moy </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element"> {{element.ID}}km/h </td>
                        </ng-container>

                        <ng-container matColumnDef="vitesse_max">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Vitesse max </th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element" (contextmenu)="onContextMenu($event, element)">
                                {{element.ID}}km/h </td>
                        </ng-container>

                        <ng-container matColumnDef="duree">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Durée</th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element" (contextmenu)="onContextMenu($event, element)">
                                {{element.ID}}sec </td>
                        </ng-container>
                        <ng-container matColumnDef="score">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Score</th>
                            <td [ngClass]="{clickItemTable : element.ID ==   selectedRowIndex }" mat-cell
                                *matCellDef="let element" (contextmenu)="onContextMenu($event, element)">
                                <circle-progress [percent]="element?.progres" [radius]="25" [outerStrokeWidth]="2"
                                    [innerStrokeWidth]="1" [outerStrokeColor]="updateColor(element?.progres)"
                                    [innerStrokeColor]="updateColor(element?.progres)" [animationDuration]="200"
                                    [showSubtitle]="false" [titleFontSize]="11"></circle-progress>
                            </td>
                        </ng-container>



                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openWindow(row.ID)"
                            (click)="selection.toggle(row)">
                        </tr>
 <!-- Row shown when there is no matching data. -->
 <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="12">
        Aucune donnée
    </td>
  </tr>

                    </mat-table>

                </div>

            </div>
            <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]"
                [showFirstLastButtons]="true">
            </mat-paginator>
        </div>
        <div class="col-6 col-md-4">
            <div class="controls">
                <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='satellite'}"
                    (click)='changeTypeMap("satellite")' class="typeMapId">satellite</button>
                <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='hybrid'}" (click)='changeTypeMap("hybrid")'
                    class="typeMapId">hybrid </button>
                <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='roadmap'}" (click)='changeTypeMap("roadmap")'
                    class="typeMapId">roadmap</button>
                <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='terrain'}" (click)='changeTypeMap("terrain")'
                    class="typeMapId">terrain</button>

            </div>


            <agm-map *ngIf="!simulation" [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="true"
                [zoomControl]="true" [mapTypeId]="typeMapIdSelect">

                <agm-marker-cluster (clusterClick)="onMouseOut(infoWindowcluster, $event)"  [calculator]="calculateFunction"
                   [styles]="clusterStyles" >

                    <agm-info-window [disableAutoPan]="false" #infoWindowcluster>
                        <p>jkldhfjklsd</p>
                    </agm-info-window>
                    <div *ngFor="let tableDataSourceposition of tableDataSource | slice:1:tableDataSource?.length-2  ; let i = index">

                        <agm-marker *ngFor="let m of tableDataSourceposition?.contact  " [latitude]="m.lat"
                            [longitude]="m.lng" [label]="tableDataSourceposition.ID" [markerDraggable]="m.draggable"
                            [markerClickable]="true" (markerClick)="zoomPosition(m.lat,m.lng,30,infoWindow, $event) "
                            (mouseOver)="onMouseOver(infoWindow, $event)" (mouseOut)="onMouseOut(infoWindow, $event)">

                            <agm-info-window [disableAutoPan]="false"
                                [isOpen]="isInfoWindowOpen(tableDataSourceposition.ID)" #infoWindow>



                                <div class="row">
                                    <div class="col-md-5">
                                        <h1>Accéleration</h1>
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-3 mb-2 d-flex" style="background: #323d415c;border-radius: 6px">
                                            <img height="40px" width="40px"
                                                src="../../../../assets/core-img/safety_score.png" alt="">
                                            <p class=" px-3 mt-2 scoreFontFamilymap">50 % </p>


                                            <p class="scoreFontFamilyCommentairemap">Score sécurité</p>
                                        </div>
                                    </div>

                                </div>






                                <table class="container">

                                    <tbody>
                                        <tr>
                                            <td>Début</td>
                                            <td>9518</td>

                                        </tr>
                                        <tr>
                                            <td>Fin</td>
                                            <td>7326</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse min</td>
                                            <td>4162</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse max</td>
                                            <td>3654</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse moy</td>
                                            <td>2002</td>

                                        </tr>
                                        <tr>
                                            <td>Durée</td>
                                            <td>4623</td>

                                        </tr>
                                    </tbody>
                                </table>


                            </agm-info-window>

                        </agm-marker>
                    </div>


                </agm-marker-cluster>
                <div *ngFor="let tableDataSourceposition of tableDataSource   ; let i = index">
                    <div *ngFor="let m of tableDataSourceposition?.contact ">
                        <agm-marker [iconUrl]="iconStart" *ngIf="i === 0" [latitude]="m.lat" [longitude]="m.lng"
                            [markerDraggable]="m.draggable" [markerClickable]="true"
                            (markerClick)="zoomPosition(m.lat,m.lng,30,infoWindow, $event) "
                            (mouseOver)="onMouseOver(infoWindow, $event)" (mouseOut)="onMouseOut(infoWindow, $event)">

                            <agm-info-window [disableAutoPan]="false" #infoWindow>



                                <div class="row">
                                    <div class="col-md-5">
                                        <h1>Accéleration</h1>
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-3 mb-2 d-flex" style="background: #323d415c;border-radius: 6px">
                                            <img height="40px" width="40px"
                                                src="../../../../assets/core-img/safety_score.png" alt="">
                                            <p class=" px-3 mt-2 scoreFontFamilymap">50 % </p>


                                            <p class="scoreFontFamilyCommentairemap">Score sécurité</p>
                                        </div>
                                    </div>

                                </div>






                                <table class="container">

                                    <tbody>
                                        <tr>
                                            <td>Début</td>
                                            <td>9518</td>

                                        </tr>
                                        <tr>
                                            <td>Fin</td>
                                            <td>7326</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse min</td>
                                            <td>4162</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse max</td>
                                            <td>3654</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse moy</td>
                                            <td>2002</td>

                                        </tr>
                                        <tr>
                                            <td>Durée</td>
                                            <td>4623</td>

                                        </tr>
                                    </tbody>
                                </table>


                            </agm-info-window>

                        </agm-marker>

                        <agm-marker [iconUrl]="iconEnd" *ngIf="i == tableDataSource.length-1" [latitude]="m.lat"
                            [longitude]="m.lng" [markerDraggable]="m.draggable" [markerClickable]="true"
                            (markerClick)="zoomPosition(m.lat,m.lng,30,infoWindow, $event) "
                            (mouseOver)="onMouseOver(infoWindow, $event)" (mouseOut)="onMouseOut(infoWindow, $event)">

                            <agm-info-window [disableAutoPan]="false" #infoWindow>



                                <div class="row">
                                    <div class="col-md-5">
                                        <h1>Accéleration</h1>
                                    </div>
                                    <div class="col-md-7">
                                        <div class="p-3 mb-2 d-flex" style="background: #323d415c;border-radius: 6px">
                                            <img height="40px" width="40px"
                                                src="../../../../assets/core-img/safety_score.png" alt="">
                                            <p class=" px-3 mt-2 scoreFontFamilymap">50 % </p>


                                            <p class="scoreFontFamilyCommentairemap">Score sécurité</p>
                                        </div>
                                    </div>

                                </div>






                                <table class="container">

                                    <tbody>
                                        <tr>
                                            <td>Début</td>
                                            <td>9518</td>

                                        </tr>
                                        <tr>
                                            <td>Fin</td>
                                            <td>7326</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse min</td>
                                            <td>4162</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse max</td>
                                            <td>3654</td>

                                        </tr>
                                        <tr>
                                            <td>Vitesse moy</td>
                                            <td>2002</td>

                                        </tr>
                                        <tr>
                                            <td>Durée</td>
                                            <td>4623</td>

                                        </tr>
                                    </tbody>
                                </table>


                            </agm-info-window>

                        </agm-marker>
                    </div>
                </div>
                <agm-polyline [strokeColor]="'#4285f4'" [strokeOpacity]="0.9">
                    <agm-icon-sequence [fixedRotation]="false" [repeat]="'60px'" [offset]="100"
                        [path]="'FORWARD_CLOSED_ARROW'">
                    </agm-icon-sequence>

                    <agm-polyline-point *ngFor="let m of markers; let i = index" [latitude]="m.lat" [longitude]="m.lng">
                    </agm-polyline-point>
                </agm-polyline>
            </agm-map>

            <agm-map *ngIf="simulation" [latitude]="30.127371" [longitude]="-9.553743" [zoom]="zoom1"
                [zoomControl]="true" [mapTypeId]="typeMapIdSelect" (mapReady)="onMapReady($event)">

            </agm-map>

            <div *ngIf="simulation" class="controlsOptions">
                <span id="speed">Speed: {{ speedMultiplier }}x</span>
                <button class="typeMapId" (click)="slow()">Slow</button>
                <button class="typeMapId" (click)="play()">Play</button>
                <button class="typeMapId" (click)="pause()">Pause</button>
                <button class="typeMapId" (click)="reset()">Reset</button>
                <button class="typeMapId" (click)="next()">Next</button>
                <button class="typeMapId" (click)="prev()">Previous</button>
                <button class="typeMapId" (click)="fast()">Fast</button>


            </div>



        </div>
    </div>

</div>
